<script>

export default {
  data() {
    return {
      headersInfo: [
        {text: 'Data Solicitação', value: 'dataSolicitacao'},
        {text: 'Tipo', value: 'tipo'},
        {text: 'Minutos Solicitados', value: 'minutosSolicitados'},
        {text: 'Status', value: 'status'}
      ],
      headerHistorico: [
        {text: 'Data', value: 'dataAlteracao'},
        {text: 'Tipo', value: 'tipo'},
        {text: 'Quem', value: 'nomePessoaAlteradora'},
      ],
      headerDetalhes: [
        {text: 'ID', value: 'id'},
        {text: 'Data', value: 'dataAlteracaoFormatted'},
        {text: 'Tipo', value: 'tipo'},
        {text: 'Quem', value: 'nomePessoaAlteradora'},
        {text: 'Minutos Disponíveis', value: 'minutosDisponiveisCompensados'},
        {text: 'Início Compensado', value: 'hrInicioCompensada'},
        {text: 'Fim Compensado', value: 'hrFimCompensada'},
      ],
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
};
</script>

<template>
  <div>
    <h4>Histórico de Compensação</h4>

    <div v-if="item.historico && item.historico.compensacao">
      <v-data-table
          v-if="item.historico.compensacao"
          class="pt-4"
          :headers="headersInfo"
          :items="[item.historico.compensacao]"
          hide-default-footer
      >
        <template v-slot:item.dataSolicitacao="{ item }">
          {{ formatDate(item.dataSolicitacao) }}
        </template>
      </v-data-table>

      <v-row v-if="item.historico.compensacao" class="pt-4">
        <v-col cols="4" md="4">
          <h5>Solicitante</h5>
          <p v-if="item.historico.compensacao.nomeSolicitante">{{ item.historico.compensacao.nomeSolicitante }}</p>
        </v-col>
        <v-col cols="8" md="4">
          <h5>Descrição</h5>
          <p v-if="item.historico.compensacao.descricao">{{ item.historico.compensacao.descricao }}</p>
        </v-col>
      </v-row>
    </div>
    <h4 class="pt-4">Histórico de alterações</h4>
    <div v-if="item.historico && item.historico.dados">
      <v-data-table
          class="pt-4"
          :headers="headerHistorico"
          :items="item.historico.dados"
          hide-default-footer
      >
        <template v-slot:item.dataAlteracao="{ item }">
          {{ formatDate(item.dataAlteracao) }}
        </template>
      </v-data-table>
    </div>
    <div v-if="item.detalhes && item.detalhes.relacoes && item.detalhes.relacoes.isAny" class="pt-4">
      <h4 class="pt-4">Detalhes</h4>
      <v-data-table
          class="pt-4"
          :headers="headerDetalhes"
          :items="item.detalhes.relacoes"
          hide-default-footer
      />
    </div>
  </div>
</template>